<mat-spinner 
    [color]="color"
    [diameter]="diameter"
    [strokeWidth]="strokeWidth"
    [mode]="mode">
</mat-spinner>
